import { Component, OnInit, Input, Inject, ComponentRef, ViewContainerRef, ComponentFactoryResolver, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';

import { CmsStudioService } from '../cms-studio.service';
import { Cms } from '../models/cms.model';
import { CmsViewDirectiveService } from './cmsviewdirective.service';
declare var $: any;

// import { DropdownTreeviewSelectI18n } from '../treeviewi18n.component';
@Component({
  selector: 'app-cms-view-directive',
  templateUrl: './cmsviewdirective.component.html',
  styleUrls: ['../cmsstudio.component.css']
  //encapsulation: ViewEncapsulation.None,
})

export class CmsViewDirectiveComponent implements OnInit {
  @Input() templateId: string;
  @Output() outputEventHere = new EventEmitter();
  cmsList: Array<Cms> = [];
  setFullWindow = false;
  constructor(
    private router: Router,
    private ngProgress: NgProgress,
    private activeRouter: ActivatedRoute,
    private cmsStudioService: CmsStudioService,
    //@Inject(CmsViewDirectiveService) private service,     
    //@Inject(ViewContainerRef) private viewContainerRef
  ) { }

  ngOnInit() {
    console.log(this.templateId);
    this.cmsStudioService.getCmsById(this.templateId)
      .subscribe(res => {
        console.log(res)
        this.cmsList.push(res.count);

        //$('.page-contents').animate({ scrollLeft: $('#cmsdirectoryview').offset().left }, 400);
      })
  }

  closePreview() {
    this.outputEventHere.emit(true);
    $('.page-contents').animate({ scrollLeft: -$('app-kbtemplate').width() + 250 }, 400);
  }

  clickEvent(e) {
    if (e.target.dataset.class = 'cmsTemplate') {
      console.log(e);
      //this.service.setRootViewContainerRef(this.viewContainerRef);
      //this.service.addDynamicComponent(e.target.dataset.id);

      this.cmsStudioService.getCmsById(e.target.dataset.id)
        .subscribe(res => {
          console.log(res)
          $('.page-contents').animate({ scrollLeft: $('app-kbtemplate').width() + 960 }, 400);
          this.cmsList.push(res.count);
        })
    }
  }

  removeCmsView(index) {
    this.cmsList.splice(index, 1);
    if (this.cmsList.length == 0)
      this.closePreview();
    else      
      $('.page-contents').animate({ scrollLeft: $('app-kbtemplate').width() }, 400);
  }
}

